import { some } from 'lodash'

import { Plan } from '../../types'

export const mealCreditsRangeByCity = (cityName: string) => {
  switch (cityName.toLowerCase()) {
    case 'new york city':
      return '3-14'
    case 'san francisco':
      return '3-14'
    case 'seattle':
      return '3-14'
    case 'singapore':
      return '2-12'
    case 'boston suburbs':
      return '5-20'
    default:
      return '4-10'
  }
}

export const taxCopyVisible = (cityName: string) => {
  return (
    ['london', 'sydney', 'melbourne', 'manchester', 'paris', 'singapore', 'auckland', 'wellington'].indexOf(
      cityName.toLowerCase(),
    ) === -1
  )
}

export const mealsRangeCopyVisible = (currentPlans: Plan[] | undefined) => {
  return some(currentPlans, (plan: Plan) => plan.spending_strategy === 'credits')
}

export const carouselBreakpoint = 1250

export const responsive = {
  desktop: {
    breakpoint: { max: 10000, min: carouselBreakpoint },
    items: 2,
  },
  mobile: {
    breakpoint: { max: carouselBreakpoint, min: 0 },
    items: 1,
  },
}
